import { withStylePrefix } from '../../common/withStylePrefix';
import { NavigationDrawerHeaderComponent, navigationDrawerHeaderTemplate } from './NavigationDrawerHeader';
import styles from './NavigationDrawerHeader.styles.scss';
export const navigationDrawerHeaderDefinition = {
    baseName: 'navigation-drawer-header',
    template: navigationDrawerHeaderTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonNavigationDrawerHeader = NavigationDrawerHeaderComponent.compose(navigationDrawerHeaderDefinition);
